<script>


import TwCard from '@/components/generic/tw-card.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwTimeLeft from '@/components/generic/tw-time-left.vue'
import TwImg from '@/components/images/tw-img.vue'

export default {
  name: 'FundraiserPageCard',
  components: { TwImg, TwTimeLeft, TwButton },
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <router-link v-if="fundraiserPage.cached" :to="{ name: 'FundraiserPagePublicPage', params: { fundraiserPageId: fundraiserPage.id, slug: fundraiserPage.slug }}">
    <div class="bg-white rounded-xl shadow-sm border border-gray-100 flex flex-col overflow-hidden h-full">
      <!-- Background Image -->
      <div class="relative">
        <tw-img :src="fundraiserPage.cover_image_url_small? fundraiserPage.cover_image_url_small: fundraiserPage.cover_image_url_small" :alt="fundraiserPage.title" class="w-full h-44 object-cover" />
        <!-- Avatar -->
        <div class="absolute inset-x-4 top-32 flex">
          <img v-if="fundraiserPage.cached.owner_avatar_url_small" class="inline-block min-w-24 h-24 w-24 rounded-full object-cover border-2 border-white bg-gray-200" :src="fundraiserPage.cached.owner_avatar_url_small" :alt="fundraiserPage.cached.owner_name">
          <span v-else class="inline-flex h-24 w-24 items-center justify-center rounded-full bg-gray-200 border-2 border-white">
          <span v-if="fundraiserPage.cached.owner_initials" class="text-3xl font-sans leading-none text-gray-400">{{ fundraiserPage.cached.owner_initials }} </span>
        </span>
        </div>
      </div>

      <!-- Content -->
      <div class="p-6 flex flex-col justify-between h-full">
        <div class="mb-6">
          <!-- Name and Description -->
          <div class="mt-8">
            <h4 v-if="fundraiserPage.cached">
              {{ fundraiserPage.cached.owner_name }}
            </h4>
            <p class="text-gray-600 text-sm mt-1">
              {{ fundraiserPage.title }}
            </p>
          </div>
        </div>
        <div>
          <!-- Progress and Funding Info -->
            <div class="flex justify-between items-end w-full mb-3 gap-2">
              <h3 v-if="fundraiserPage.cached" class="text-amber-500">
                ${{ fundraiserPage.cached.raised_formatted }}
                <span class="text-sm font-normal text-gray-900">Raised</span>
                <!-- ${{ fundraiser.cached.goal_formatted }} Goal -->
              </h3>
              <h5 v-if="fundraiserPage.cached" class="text-amber-500">
                {{ fundraiserPage.cached.percentage_raised }}%
              </h5>
            </div>
            <div v-if="fundraiserPage.cached" class="w-full bg-gray-300 rounded-full h-3 mt-2">
              <div class="bg-amber-500 h-3 rounded-full max-w-full" :style="`width: ${fundraiserPage.cached.percentage_raised}%;`" />
            </div>
            <tw-time-left class="pt-2 text-sm mb-7 text-gray-600" :deadline="fundraiserPage.deadline" detailed />
          <!-- Link -->
          <tw-button target="_blank" :to="{ name: 'FundraiserPagePublicPage', params: { fundraiserPageId: fundraiserPage.id, slug: fundraiserPage.slug }}" variant="light" class="flex justify-center">
            View Fundraiser Page
          </tw-button>
        </div>
      </div>
    </div>
</router-link>
</template>


<style scoped>

</style>
